import { shallowRef } from 'vue'
import type { Router } from 'vue-router'
import { pageTitleMap } from '../config/constant'

export const routeLoadFailure = shallowRef<{ fullPath: string; message: string } | null>(null)

export function isRouteModuleLoadError(error: unknown): boolean {
    const message = String((error as { message?: unknown })?.message || error || '')
    if (/importing a module script failed|failed to fetch dynamically imported module|error loading dynamically imported module|unable to preload css|loading (?:css )?chunk .*failed/i.test(message)) return true
    // Vite 2 rejects its stylesheet preload promise with the link's ErrorEvent.
    const event = error as { type?: string; target?: { tagName?: string; rel?: string; href?: string } } | null
    return event?.type === 'error' && event.target?.tagName === 'LINK' && event.target.rel === 'stylesheet'
        && typeof event.target.href === 'string' && /\.css(?:[?#]|$)/i.test(event.target.href)
}

export function routeReloadPath(fullPath: string, timestamp = Date.now()): string {
    if (!fullPath.startsWith('/') || fullPath.startsWith('//')) throw new Error('Invalid route path')
    const url = new URL(fullPath, 'http://route.local')
    if (url.origin !== 'http://route.local') throw new Error('Invalid route origin')
    url.searchParams.set('_reload', String(timestamp))
    return url.pathname + url.search + url.hash
}

export function installRouteLoadRecovery(router: Router) {
    const stopError = router.onError((error, to) => {
        console.error(error)
        if (!isRouteModuleLoadError(error)) return
        const title = pageTitleMap[String(to.name)] || '页面'
        routeLoadFailure.value = {
            fullPath: to.fullPath,
            message: `${title}加载失败，请检查网络或刷新后重试。`
        }
    })
    const stopAfter = router.afterEach((_to, _from, failure) => {
        if (!failure) routeLoadFailure.value = null
    })
    return () => { stopError(); stopAfter() }
}
